"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by pavel.arakelyan on 11/14/17.
 */
var ReportTableView = /** @class */ (function () {
    function ReportTableView(rowModel, columnsModel) {
        this._rowModel = rowModel;
        this._columnsModel = columnsModel;
    }
    Object.defineProperty(ReportTableView.prototype, "rows", {
        get: function () {
            return this._rowModel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReportTableView.prototype, "columns", {
        get: function () {
            return this._columnsModel;
        },
        enumerable: true,
        configurable: true
    });
    return ReportTableView;
}());
exports.ReportTableView = ReportTableView;
//# sourceMappingURL=report-table-view.model.js.map